export const permissionScopes = {
  ADMIN: 'org_admin',
  NON_ADMIN: 'agent',
  CALENDAR_USER: 'calendar_user',
  VIDEO_USER: 'video'
}

export const emailScopes = {
  // depreciated
  SALES: 'SALES_SEQUENCES'
}

export const conversationScopes = {
  ALL: 'convo-ALL',
  ONLY_MINE: 'convo-ONLY_MINE',
  NO_PARTICIPANTS: 'convo-WITH_NO_PARTICIPANTS'
}

export const requiredScopes = {
  MEMBER: 'member'
}

export const allScopes = {
  ...permissionScopes,
  ...emailScopes,
  ...conversationScopes,
  ...requiredScopes
}



// WEBPACK FOOTER //
// ./src/scripts/components/settings/team/TeamConstants.js